const _ = require('lodash');
let _shopperService, _rrPubSub;
const atmAddToTrolleyMapper = require('./atmmapper/add-to-trolley-mapper');
const atmRemoveFromTrolleyMapper = require('./atmmapper/remove-from-trolley-mapper');
const atmClearTrolleyMapper = require('./atmmapper/clear-trolley-mapper');
const checkoutNavigationMapper = require('../collectionzone/atm/checkout-navigation-mapper');
const { APPY_DEALS_PAGE_SOURCE_ID, APPY_DEALS_EVENT_DATA } = require('../../../common/utility/appyDealsCheck');

function TrolleyService($rootScope, restangular, $q, loginService, shopperService, RRPubSub, atm, DecorateAdditionalDetails, $log, $state, $stateParams, bwsNotificationService, $timeout, inMemoryStorage) {
    /*
     * Service for interacting with the trolley.
     * Supports actions like adding, removing, updating, and clearing.
     * Depends on Restangular.
     */
    this._trolleyRoute = restangular.withConfig(function (RestangularConfigurer) {
        RestangularConfigurer.setFullResponse(true);
    }).one('Trolley');

    this.$rootScope = $rootScope;

    this.$q = $q;

    this._loginService = loginService;
    _shopperService = shopperService;
    _rrPubSub = RRPubSub;
    // The items
    this.trolleyProducts = [];

    //Totals information
    this.totals = {};
    this.salePriceTotal = 0;
    this.listPriceTotal = 0;
    this.savedPrice = 0;
    this.deliveryFee = {};
    this.isTotalReady = false;
    this.wowRewardsSummary = {};
    this.$state = $state;
    this._decorator = DecorateAdditionalDetails;
    this.$timeout = $timeout;
    this.bwsNotificationService = bwsNotificationService;
    this.shopperService = shopperService;
    this.atm = atm;
    this.$log = $log;
    this.inMemoryStorage = inMemoryStorage;
    this.updateRequestCount = 0;
    this.areaViewed = '';
    this.routeLoaded = true;
    this.$stateParams = $stateParams;

    $rootScope.$on('$stateChangeSuccess', () => {
        if (!this.routeLoaded) {
            this.atm.pushTrolleyProductsMapper(this.trolleyProducts);
        }
        this.routeLoaded = false;
    });

    $rootScope.$on('trolley:invalidatePricing', () => { this._invalidatePricing(); });

    // send an analytics event when the trolley is updated
    $rootScope.$on('trolley:update', (event, msg) => {
        try {
            if (!msg) return;

            if (msg.productsRemoved) {
                msg.productsRemoved = this._decorator(msg.productsRemoved);
            } else if (msg.product && Array.isArray(msg.product.AdditionalDetails)) {
                msg.product = this._decorator([msg.product])[0];
            }

            this.setCrossSellType(msg, $stateParams);

            msg.crossSellType = $stateParams.crossSellType;

            // AppyDeals specific requirement
            // for product detail page to read 'AppyDealsEventData' which only set from previous visited Appy Deals product list page
            // and set the crossSellType
            const appyDealsEventData = this.inMemoryStorage.getItem(APPY_DEALS_EVENT_DATA);

            if ($stateParams.source === APPY_DEALS_PAGE_SOURCE_ID) {
                if (appyDealsEventData && appyDealsEventData.crossSellType) {
                    msg.crossSellType = appyDealsEventData.crossSellType;
                }
            }

            if (this.inMemoryStorage.getItem('addToCartEventData')) {
                msg.eventData = this.inMemoryStorage.getItem('addToCartEventData');
                this.inMemoryStorage.removeItem('addToCartEventData');
            }

            // push the event to analytics
            if (msg.type === 'clear' && msg.area) {
                this.atm.push(msg, atmClearTrolleyMapper);
            } else if (msg.type === 'update' && msg.product.Quantity > 0) {
                msg.startCart = this.trolleyProducts.length === 1 ? 'yes' : 'no';

                // when user add more Appy Deal product to the cart
                if (appyDealsEventData && appyDealsEventData.productStockcode === msg.product.Stockcode) {
                    msg.crossSellType = appyDealsEventData.crossSellType;
                }

                this.atm.push(msg, atmAddToTrolleyMapper);
                // send add to cart to RR
                _rrPubSub.publish(_rrPubSub.EVENTS.ADD_TO_CART, { id: msg.product.Stockcode });
            } else if (msg.type === 'remove' || (msg.type === 'update' && msg.product.Quantity < 0)) {
                this.atm.push(msg, atmRemoveFromTrolleyMapper);
            }

        } catch (e) {
            $log.log('Oups something went wrong:');
            $log.log(e);
        }
    });
}

TrolleyService.prototype._invalidatePricing = function () {
    this.getTrolley();
};

TrolleyService.prototype._updateTrolley = function (response) {
    this.trolleyProducts = this._decorator(response.data.AvailableItems);
    this.unavailableProducts = this._decorator(response.data.UnavailableItems);
    this.restrictedProducts = this._decorator(response.data.RestrictedItems);
    this.partiallyUnavailableProducts = this._decorator(response.data.PartiallyUnavailableItems);
    this.itemCount = response.data.TrolleyItemCount;
    this.cartBannerMessage = response.data.CartBannerMessage;

    // Update Totals
    this.totals = response.data.Totals;
    this.salePriceTotal = response.data.Totals.Total;
    this.savedPrice = response.data.Totals.TotalSavings;
    this.deliveryFee = response.data.DeliveryFee;
    this.wowRewardsSummary = response.data.WowRewardsSummary;
    this.isTotalReady = true;
    this.atm.pushTrolleyProductsMapper(this.trolleyProducts);
    return response;
};


TrolleyService.prototype.setCrossSellType = function (msg, state) {
    if (!state.crossSellType || state.crossSellType.length < 8 || !msg.product.Source || !msg.area) {
        return;
    }
    if (/.*Breinify.*/.test(msg.product.Source)) {
        state.crossSellType = `${state.crossSellType.substr(0, 8)}breinify-${state.crossSellType.substr(8)}`;
        msg.area = `Breinify ${msg.area}`;
    } else if (/.*RichRelevance.*/.test(msg.product.Source)) {
        state.crossSellType = `${state.crossSellType.substr(0, 8)}rich relevance-${state.crossSellType.substr(8)}`;
        msg.area = `Rich Relevance ${msg.area}`;
    }
};

TrolleyService.prototype.validateQuantity = function (product, quantity, trolleyItemQuantity) {
    const minQty = product.MinimumQuantity;
    const maxPurchaseLimit = parseInt(product.ProductData.maxpurchasequantity) || product.SupplyLimit;

    // Quantity is not a number
    if (quantity === '' || isNaN(quantity)) {
        this._manageErrorMessage(product, 'Invalid');
        return false;
    }

    // Quantity is the same as what is already in the trolley
    if (typeof trolleyItemQuantity !== 'undefined' && quantity === trolleyItemQuantity) {
        return false;
    }

    // Quantity is greater than allowed
    if (quantity > maxPurchaseLimit) {
        this._manageErrorMessage(product, 'QtyIsGreater');
        return true; // Valid update, service will set the maximum
    }

    // Quantity is less than or equal to Minimum quantity
    if (quantity < minQty) {
        this._manageErrorMessage(product, 'Invalid');
        return false;
    }

    // quantity is valid
    this._manageErrorMessage(product, 'false');
    return true;
};

TrolleyService.prototype._manageErrorMessage = function (product, errorType) {
    const trolleyItem = _.find(this.trolleyProducts, { Stockcode: product.Stockcode });
    if (typeof trolleyItem !== 'undefined' && trolleyItem !== null) {
        trolleyItem.HasError = errorType;
    }
};

TrolleyService.prototype._setScreenReaderMessage = function (stockcode, state) {
    const item = this.getTrolleyItem(stockcode);
    if (!item) {
        // If the item is no longer in the trolley for some reason, shortcut the method.
        // This can happen when trying to add too many delivery passes to the trolley.
        return;
    }

    switch (state) {
        case 'add':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' added to trolley. Quantity: ' + item.Quantity;
            break;
        case 'update':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' quantity in trolley has been updated to ' + item.Quantity;
            break;
        case 'remove':
            this.srMessage = item.Name + ' ' + item.PackageSize + ' removed from trolley';
            break;
        case 'clear':
            this.srMessage = 'All products have been removed from the trolley.';
            break;
        case 'clearOOS':
            this.srMessage = 'All out of stock products have been removed from the trolley.';
            break;
    }
};

TrolleyService.prototype.getTrolley = function () {
    this.isTotalReady = false;
    return this._trolleyRoute.get()
        .then(this._updateTrolley.bind(this));
};

TrolleyService.prototype.getTrolleyItem = function (stockcode) {
    let product = _.find(this.trolleyProducts, { Stockcode: stockcode });
    if (!product) {
        product = _.find(this.restrictedProducts, { Stockcode: stockcode });
    }
    if (!product) {
        product = _.find(this.unavailableProducts, { Stockcode: stockcode });
    }
    return product;
};

function postToTrolley(product, quantity, area) {
    this.isTotalReady = false;
    return this._trolleyRoute.one('Items/' + product.Stockcode).customPUT({ type: 'update', stockcode: product.Stockcode, quantity, SearchTerm: this.$state.params.searchTerm, adId: product.adId })
        .then(response => {
            this._updateTrolley(response);
            this.validateQuantity(product, quantity);
            this._setScreenReaderMessage(product.Stockcode, 'add');
            const addedProduct = _.assign({}, response.data.RecentlyAddedItems[0], product);
            this.$rootScope.$broadcast('trolley:update', { type: 'update', product: addedProduct, quantity, area, response: response.data, headers: response.headers });
            return response;
        });
}

function showLoginPrompt(reason) {
    let loginMessage;

    switch (reason) {
        case 'AgeRestricted':
            loginMessage = this._loginService.LoginToAddRestrictedProductMessage;
            break;
        case 'MaxItemsReached':
            loginMessage = this._loginService.LoginToAddMoreProductsMessage;
            break;
        default:
            loginMessage = undefined;
    }

    this.GuestTrolleyLoginReminderShown = true;

    return this._loginService.promptForLogin(loginMessage)
        .catch(() => {
            return this.$q.reject('Invalid');
        });
}

TrolleyService.prototype.addItemToTrolley = function (product, quantity, area) {
    if (!this.validateQuantity(product, quantity)) {
        return this.$q.reject('Invalid');
    }

    if (_shopperService.currentUser.isGuest && product.AgeRestricted) {
        let loginPromptReason;
        if (product.AgeRestricted) {
            loginPromptReason = 'AgeRestricted';
        } else {
            loginPromptReason = undefined;
        }
        const loginPromise = showLoginPrompt.call(this, loginPromptReason);
        return !product.AgeRestricted
            ? postToTrolley.call(this, product, quantity, area)
            : loginPromise.then(() => {
                return _shopperService.AllowRestrictedDepartment
                    ? postToTrolley.call(this, product, quantity, area)
                    : this.$q.reject();
            });

    }

    return postToTrolley.call(this, product, quantity, area);
};

function moveItemPositionInArray(myList, oldIndex, newIndex) {
    if (newIndex >= myList.length) {
        let k = newIndex - myList.length;
        while ((k--) + 1) {
            myList.push(undefined);
        }
    }
    myList.splice(newIndex, 0, myList.splice(oldIndex, 1)[0]);
    return myList; // for testing purposes
}

TrolleyService.prototype.keepUpdatedProductOrder = function (updatedItemOldValues, response) {
    // find the position of the updated item and add them to the same position if they are still in the trolley
    if (updatedItemOldValues) {
        const parentStockcode = updatedItemOldValues.ParentStockCode || updatedItemOldValues.ParentStockcode;
        // check if the product is still in the AvailableItems list
        const newPosition = _.findIndex(response.data.AvailableItems, function (item) { return item.ParentStockcode === parentStockcode; });
        if (newPosition !== -1) {
            // get the last position of the updated items in the trolley
            const oldPosition = _.findIndex(this.trolleyProducts, function (item) { return item.ParentStockcode === parentStockcode; });
            if (oldPosition !== -1) {
                moveItemPositionInArray(response.data.AvailableItems, oldPosition, newPosition);
            }
        }
    }
    return response;
};

TrolleyService.prototype.updateTrolleyItem = function (product, quantity, area) {
    this.isTotalReady = false;
    this.updateRequestCount++;
    const requestVersion = this.updateRequestCount;

    return this._trolleyRoute.one('Items/' + product.Stockcode).customPUT({ stockcode: product.Stockcode, quantity, adId: product.adId })
        .then((response) => {
            return this.keepUpdatedProductOrder(product, response);
        })
        .then(response => {
            if (requestVersion >= this.updateRequestCount) { // check if it's the latest request
                this._updateTrolley(response);
                this.validateQuantity(product, quantity);
                this._setScreenReaderMessage(product.Stockcode, 'update');
                return response;
            }
            return this.$q.reject();
        }).then((response) => {
            const addedProduct = _.assign({}, product, response.data.RecentlyAddedItems[0]);
            this.$rootScope.$broadcast('trolley:update', { type: 'update', product: addedProduct, area, response: response.data, headers: response.headers });
            this.validateQuantity(product, quantity);
            return response.data;
        });
};

// area is used by analytics for context
TrolleyService.prototype.addOrUpdateTrolley = function (product, area) {
    return product.IsInTrolley ?
        this.updateTrolleyItem(product, product.DisplayQuantity, area)
        : this.addItemToTrolley(product, product.DisplayQuantity, area);
};

TrolleyService.prototype.removeTrolleyItem = function (stockcode, product, area) {
    this.isTotalReady = false;
    return this._trolleyRoute.doPOST({ Stockcode: stockcode }, 'Remove')
        .then(response => {
            this._setScreenReaderMessage(stockcode, 'remove');
            this._updateTrolley(response);
            this.$rootScope.$broadcast('trolley:update', { type: 'remove', product, area, stockcode });
            return response;
        });
};

TrolleyService.prototype.removeItems = function (stockcodes) {
    this.isTotalReady = false;
    return this._trolleyRoute.doPOST({ Stockcodes: stockcodes }, 'RemoveItems')
        .then(response => {
            this._updateTrolley(response);
            this.$rootScope.$broadcast('trolley:update');
        });
};

TrolleyService.prototype.cleanTrolleyItems = function (area) {
    this.isTotalReady = false;
    return this._trolleyRoute.doPOST({}, 'UpdateQuantityAndRemoveUnavailable')
        .then(response => {
            const broadcasts = [];
            if ((response.data && response.data.Success) || (response.Success)) {
                //call remove analytics event on each unavailable item
                if (this.unavailableProducts != null && this.unavailableProducts.length > 0) {
                    for (let i = 0; i < this.unavailableProducts.length; i++) {
                        const product = this.unavailableProducts[i];
                        const stockcode = product.Stockcode;
                        broadcasts.push({ type: 'remove', product, area, stockcode });
                    }
                }

                //call remove analytics event on each partially unavailable item
                if (this.partiallyUnavailableProducts != null && this.partiallyUnavailableProducts.length > 0) {
                    for (let i = 0; i < this.partiallyUnavailableProducts.length; i++) {
                        const product = this.partiallyUnavailableProducts[i];
                        const stockcode = product.Stockcode;
                        broadcasts.push({ type: 'remove', product, area, stockcode });
                    }
                }
            }
            return this.getTrolley().then((trolleyResponse) => {
                for (let i = 0; i < broadcasts.length; i++) {
                    this.$rootScope.$broadcast('trolley:update', broadcasts[i]);
                }
                return Promise.resolve(trolleyResponse);
            });
        });
};

TrolleyService.prototype.clearTrolley = function (area) {
    this.isTotalReady = false;

    return this._trolleyRoute.doPOST({}, 'Clear')
        .then(response => {
            const productsRemoved = _.cloneDeep(this.trolleyProducts);
            this._updateTrolley(response);
            this.$rootScope.$broadcast('trolley:update', { type: 'clear', productsRemoved, area });
            this._setScreenReaderMessage('', 'clear');
        }).then(() => {
            return this.getTrolley();
        });
};

TrolleyService.prototype.addItemsToTrolley = function (items) {
    this.isTotalReady = false;
    const mappedProducts = _.map(_.filter(items, function (product) { return product.IsAvailable === true && product.DisplayQuantity > 0; }), function (item) {
        const newQty = item.QuantityInTrolley !== 0 ? item.QuantityInTrolley + item.DisplayQuantity : item.DisplayQuantity;
        return { stockcode: item.Stockcode, quantity: newQty, source: item.Source };
    });

    return this._trolleyRoute.post('AddItems', { products: mappedProducts })
        .then(response => {
            this._updateTrolley(response);
            this._setScreenReaderMessage('', 'items added');
            return response;
        }).then((response) => {
            this.$rootScope.$broadcast('trolley:update');
            return response;
        });
};

TrolleyService.prototype.saveTrolleyAsList = function (name) {
    return this._trolleyRoute.one('SaveAsList').doPOST({ Name: name });
};

TrolleyService.prototype.reorder = function (orderId) {
    this.shopperService.reorder(orderId).then(response => {
        let responseData = response;
        if (response && response.data && response.data.AvailableItems) {
            responseData = response.data;
        }
        if (responseData.AvailableItems.length === 0 &&
            responseData.PartiallyUnavailableItems.length === 0 &&
            responseData.UnavailableItems.length === 0) {

            this.bwsNotificationService.error('Oops, these products are not available in the current store');

        } else {
            const startCart = this.trolleyProducts.length === 0 ? 'yes' : 'no';
            this.getTrolley()
                .then((trolleyResponse) => {
                    this.$state.go('checkout')
                        .then(() => {
                            this.atm.push({
                                trolleyProducts: this.trolleyProducts,
                                startCart,
                                area: 'reorder',
                                crossSellType: this.$stateParams.crossSellType,
                                eventId: trolleyResponse.headers('x-eventid')
                            }, atmAddToTrolleyMapper);
                            this.atm.push({ trolleyProducts: this.trolleyProducts }, checkoutNavigationMapper);
                        });
                });

            this.$timeout(() => {
                this.bwsNotificationService.success('Success! To save time we\'ve used your latest preferences');
            }, 2000, false);
        }

    }, () => {
        this.bwsNotificationService.error('Oops, looks like something went wrong');
    });
};

TrolleyService.prototype.initialise = function () {
    //as for now, nothing needs to be initialised, this used as a placehoder for future usage.
};

module.exports = TrolleyService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/trolley-service.js
 **/